<template>
    <b-row>
        <b-col cols="12" class="subtitle h3 light mb-3 mb-lg-3">
            {{ index + 1 + ' - ' + entradaLocal.name }}
        </b-col>

        <b-col cols="12" lg="4">
            <FormInput
                v-model="entradaLocal.nombre"
                :disabled="desactivar"
                label="Nombre"
                @input="updateField('nombre', $event)"
            />
        </b-col>

        <b-col cols="12" lg="4">
            <FormInput
                v-model="entradaLocal.apellidos"
                :disabled="desactivar"
                label="Apellidos"
                @input="updateField('apellidos', $event)"
            />
        </b-col>

        <b-col cols="12" lg="4">
            <DocumentoTipo
                :value="entradaLocal.documento_tipo"
                @input="val => updateField('documento_tipo', val)"
            />
        </b-col>

        <b-col cols="12" lg="4">
            <DocumentoValor
                :type="entradaLocal.documento_tipo"
                :value="entradaLocal.dni"
                @input="val => updateField('dni', val)"
            />
        </b-col>

        <b-col cols="12" lg="4">
            <FormInput
                v-model="entradaLocal.email"
                :disabled="desactivar"
                label="Email"
                @input="updateField('email', $event)"
            />
        </b-col>
    </b-row>
</template>

<script>
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";

    export default {
        props: {
            entrada: { type: Object, required: true },
            index: Number,
            desactivar: Boolean,
        },
        data() {
            return {
                entradaLocal: { ...this.entrada },
            };
        },
        watch: {
            entrada: {
                handler(newVal) {
                    this.entradaLocal = { ...newVal };
                },
                deep: false,
            },
        },
        methods: {
            updateField(field, value) {
                this.entradaLocal = { ...this.entradaLocal, [field]: value };
                this.$emit("update:entrada", this.entradaLocal);
            },
        },
        components: {
            DocumentoTipo, DocumentoValor
        }
    };
</script>
